import { useState } from 'react';

const HeroSection = () => {
  const [showVideo, setShowVideo] = useState(false);

  const scrollToRegister = () => {
    const registerSection = document.getElementById('register');
    if (registerSection) {
      registerSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section 
        id="home" 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/9b707f4fd6a6962f77481fd4c89674da.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white w-full">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
              CMAP運動健康品格
              <span className="block text-emerald-400">寒假營隊</span>
            </h2>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 text-gray-200 leading-relaxed px-4">
              多元課程選擇，專業師資指導，讓孩子在運動中培養健康體魄，在活動中建立良好品格，度過充實快樂的寒假時光
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
              <button 
                onClick={scrollToRegister}
                className="w-full sm:w-auto bg-emerald-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
              >
                <div className="flex items-center justify-center space-x-2">
                  <span>立即報名</span>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </button>
              <button 
                onClick={() => setShowVideo(true)}
                className="w-full sm:w-auto border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-play-circle-line"></i>
                  </div>
                  <span>觀看介紹</span>
                </div>
              </button>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
          <div className="w-6 h-6 flex items-center justify-center text-white">
            <i className="ri-arrow-down-line text-2xl"></i>
          </div>
        </div>
      </section>

      {/* Course Schedule Modal */}
      {showVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-white rounded-xl sm:rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center p-4 sm:p-6 border-b sticky top-0 bg-white z-10">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">CMAP運動健康品格夏令營 - 每週一至五每日課程假期表</h3>
              <button
                onClick={() => setShowVideo(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer flex-shrink-0 ml-2"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="p-4 sm:p-6">
              {/* Course Schedule Image */}
              <div className="mb-6">
                <img 
                  src="https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/a67599afad616f9c0d227c5341e46d5d.jpeg"
                  alt="CMAP營隊課程表"
                  className="w-full h-auto rounded-xl shadow-lg"
                />
              </div>

              {/* Course Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-6">
                <div className="bg-pink-50 p-6 rounded-xl">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-8 h-8 flex items-center justify-center bg-pink-500 text-white rounded-full mr-3">
                      <i className="ri-sun-line"></i>
                    </div>
                    上午主修課程
                  </h4>
                  <p className="text-sm text-gray-600 mb-3">每週一、三、五上課選1個</p>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div className="bg-white p-2 rounded">軟式飛盤</div>
                    <div className="bg-white p-2 rounded">科學實驗</div>
                    <div className="bg-white p-2 rounded">躲避球</div>
                    <div className="bg-white p-2 rounded">3D列印</div>
                    <div className="bg-white p-2 rounded">漆彈生存遊戲</div>
                    <div className="bg-white p-2 rounded">點心烘焙</div>
                    <div className="bg-white p-2 rounded">競技籃球</div>
                    <div className="bg-white p-2 rounded">雷射雕刻</div>
                    <div className="bg-white p-2 rounded">羽毛球</div>
                  </div>
                </div>

                <div className="bg-orange-50 p-6 rounded-xl">
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-500 text-white rounded-full mr-3">
                      <i className="ri-sun-fill"></i>
                    </div>
                    上午副修課程
                  </h4>
                  <p className="text-sm text-gray-600 mb-3">每週二、四上課選1個</p>
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div className="bg-white p-2 rounded">數學課程</div>
                    <div className="bg-white p-2 rounded">小小廣播</div>
                    <div className="bg-white p-2 rounded">英文課程</div>
                    <div className="bg-white p-2 rounded">遙控賽車</div>
                    <div className="bg-white p-2 rounded">正音課程</div>
                    <div className="bg-white p-2 rounded">遙控飛機</div>
                    <div className="bg-white p-2 rounded">小小魔術師</div>
                    <div className="bg-white p-2 rounded">輕黏土拼貼</div>
                    <div className="bg-white p-2 rounded">游泳課程</div>
                    <div className="bg-white p-2 rounded">流行街舞</div>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-xl mb-6">
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full mr-3">
                    <i className="ri-gamepad-line"></i>
                  </div>
                  下午俱樂部課程
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
                  <div className="bg-white p-2 rounded text-center">圍巾編織</div>
                  <div className="bg-white p-2 rounded text-center">鑽石貼畫</div>
                  <div className="bg-white p-2 rounded text-center">樂樂棒球</div>
                  <div className="bg-white p-2 rounded text-center">疊杯疊疊樂</div>
                  <div className="bg-white p-2 rounded text-center">兒童油畫</div>
                  <div className="bg-white p-2 rounded text-center">象棋黑白棋</div>
                  <div className="bg-white p-2 rounded text-center">羽毛球</div>
                  <div className="bg-white p-2 rounded text-center">競技籃球</div>
                  <div className="bg-white p-2 rounded text-center">拼豆</div>
                  <div className="bg-white p-2 rounded text-center">撲克UNO牌</div>
                  <div className="bg-white p-2 rounded text-center">漆彈生存遊戲</div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white p-4 sm:p-6 rounded-xl text-center">
                <h4 className="text-xl sm:text-2xl font-bold mb-3">豐富多元的課程選擇</h4>
                <p className="text-base sm:text-lg mb-4">讓孩子在運動中成長，在學習中快樂</p>
                <button
                  onClick={() => {
                    setShowVideo(false);
                    scrollToRegister();
                  }}
                  className="bg-white text-emerald-600 px-6 sm:px-8 py-2 sm:py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap inline-block"
                >
                  立即為孩子報名
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeroSection;
